import apiHelper from '@/services/helper'
import apiHelperFinance from '@/services/helperFinance'

import store from '@/store/root'

const searchScgAccount = async (param) => {
    try {
        let url = '/admin/courier/search-scg'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getListProvider = async () => {
    try {
        let url = '/admin/courier/provider/get-all'
        return (await apiHelperFinance.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getCourierAccount = async (param) => {
    try {
        let url = '/admin/courier/account/get-all'
        return (await apiHelper.getWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getCourierByUserID = async (param) => {
    try {
        let url = '/admin/courier/user/get'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createCourierAccount = async (param) => {
    try {
        let url = '/admin/courier/account/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deleteCourierAccount = async (param) => {
    try {
        let url = '/admin/courier/account/multi-delete'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateCourierAccount = async (param) => {
    try {
        let url = '/admin/courier/user/update'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getTrackingHistory = async (param) => {
    try {
        let url = '/admin/courier/get-tracking-history'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getLogCreateShipment = async (param) => {
    try {
        let url = '/admin/courier/get-log'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const notifyCourier = async ({ shopId, courierAccountId, parcelNumber, remark }) => {
    try {
        let url = '/admin/courier/flash/notify'
        let param = {
            shop_id: shopId,
            courier_account_id: courierAccountId,
            parcel_number: parseInt(parcelNumber),
            remark: remark,
            admin_email: store.get('user/objUser').email
        }
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getNotifyHistory = async ({ date, search }) => {
    try {
        let url = '/admin/courier/flash/get-all-notification'
        let param = {
            date,
            search
        }
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateListSorting = async (assortCode) => {
    try {
        let url = '/admin/courier/provider/update-assort-scg'
        let param = {
            assort_code: assortCode
        }
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw error
    }
}

const getListSorting = async () => {
    try {
        let url = '/admin/courier/provider/get-assort-scg'
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw error
    }
}

const cancelNotify = async (param) => {
    try {
        let url = '/admin/courier/flash/cancel-notify'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, { ...param, admin_email: store.get('user/objUser').email })).data
    } catch (error) {
        throw new Error(error)
    }
}

const cutTime = async (param) => {
    try {
        let url = '/admin/courier/provider/update-cut-off-time'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getAllScgnotify = async (param) => {
    try {
        let url = '/admin/courier/scg/get-all-notification'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getBestTrackingAll = async (param) => {
    try {
        let url = '/admin/courier/best/get-all'
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url, param)).data
    } catch (error) {
        throw error
    }
}

const createBestTracking = async (param) => {
    try {
        let url = '/admin/courier/best/create-muti'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getAvailableZipcode = async (param) => {
    try {
        let url = '/admin/courier/provider/get-available-zipcode'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateAvailableZipcode = async (param) => {
    try {
        let url = '/admin/courier/provider/update-available-zipcode'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getExceptZipcode = async (param) => {
    try {
        let url = '/admin/courier/provider/get-except-zipcode'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateExceptZipcode = async (param) => {
    try {
        let url = '/admin/courier/provider/update-except-zipcode'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createCourierBooking = async (param) => {
    try {
        let url = '/admin/courier/booking/create'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateCourierBooking = async (param) => {
    try {
        let url = '/admin/courier/booking/update'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getAllCourierBooking = async (param) => {
    try {
        let url = '/admin/courier/booking/get-all'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchCourierBooking = async (param) => {
    try {
        let url = '/admin/courier/booking/search'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const courierBookingConfirm = async (param) => {
    try {
        let url = '/admin/courier/booking/confirm'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const courierBookingChange = async (param) => {
    try {
        let url = '/admin/courier/booking/change-to-picked-up'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deleteCourierBooking = async (param) => {
    try {
        let url = '/admin/courier/booking/delete?courier_booking_id=' + param
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const shipflowCourierBookingScg = async (param) => {
    try {
        let url = '/admin/courier/booking/scg'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const shipflowCourierBookingFlash = async (param) => {
    try {
        let url = '/admin/courier/booking/flash'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchBookingCalendar = async (param) => {
    try {
        let url = '/admin/courier/booking/calendar/search'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getGropShopBookingCalendar = async (param) => {
    try {
        let url = '/admin/courier/booking/calendar/get-group-shop'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createHolidayBookingCalendar = async (param) => {
    try {
        let url = '/admin/courier/booking/holiday/create'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const courierBookingCancel = async (param) => {
    try {
        let url = '/admin/courier/booking/cancel'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateHolidayBookingCalendar = async (param) => {
    try {
        let url = '/admin/courier/booking/holiday/update'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getBookingCourierProvider = async (param) => {
    try {
        let url = '/admin/courier/booking/get-courier-provider'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deleteHolidayBookingCalendar = async (param) => {
    try {
        let url = '/admin/courier/booking/holiday/delete?courier_holiday_id=' + param
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const pullStatusOrderList = async (param) => {
    try {
        let url = '/admin/courier/pull-status'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        console.error(error)
    }
}

const getAllThaipostTracking = async () => {
    try {
        let url = '/admin/courier/get-barcode-thai-post'
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw error
    }
}

const createThaipostEmsTracking = async (params) => {
    try {
        let url = '/admin/courier/import-barcode-thai-post'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, params)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOrderStatusType = async () => {
    try {
        let url = '/admin/order/get-order-status'
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getProviderType = async () => {
    try {
        let url = '/admin/courier/provider/get-all'
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    searchScgAccount,
    getListProvider,
    getCourierAccount,
    getCourierByUserID,
    createCourierAccount,
    deleteCourierAccount,
    updateCourierAccount,
    getTrackingHistory,
    getLogCreateShipment,
    notifyCourier,
    getNotifyHistory,
    getListSorting,
    updateListSorting,
    cancelNotify,
    cutTime,
    getAllScgnotify,
    getBestTrackingAll,
    createBestTracking,
    getAvailableZipcode,
    updateAvailableZipcode,
    getExceptZipcode,
    updateExceptZipcode,
    searchCourierBooking,
    courierBookingConfirm,
    deleteCourierBooking,
    courierBookingChange,
    createCourierBooking,
    getAllCourierBooking,
    updateCourierBooking,
    shipflowCourierBookingScg,
    shipflowCourierBookingFlash,
    searchBookingCalendar,
    getGropShopBookingCalendar,
    createHolidayBookingCalendar,
    courierBookingCancel,
    getBookingCourierProvider,
    updateHolidayBookingCalendar,
    deleteHolidayBookingCalendar,
    pullStatusOrderList,
    getAllThaipostTracking,
    createThaipostEmsTracking,
    getOrderStatusType,
    getProviderType
}
